import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


import { library } from '@fortawesome/fontawesome-svg-core'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VueSession from 'vue-session'

const fb = require('./config/db.js')


library.add(faPhone);
library.add(faEnvelope);
library.add(faSignOutAlt);

Vue.component('font-awesome-icon', FontAwesomeIcon)

let rcaLogado = '';


Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VueSession)

Vue.config.productionTip = false

fb.auth.signInWithEmailAndPassword('ti@disbon.com.br', 'Disbon2019').then();

new Vue({
  router,
  rcaLogado, 
  render: h => h(App),
}).$mount('#app')
